var _rect, _rect2, _path;
var _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) { o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } } return t; }
import React from "react";
var SvgBiCellphone = function SvgBiCellphone(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "#F3F7FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#C4D0D8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9844 30V15.9844H18.9844V30H27.9844ZM22.4062 33.5625C22.7188 33.8438 23.0781 33.9844 23.4844 33.9844C23.8906 33.9844 24.2344 33.8438 24.5156 33.5625C24.8281 33.25 24.9844 32.8906 24.9844 32.4844C24.9844 32.0781 24.8281 31.7344 24.5156 31.4531C24.2344 31.1406 23.8906 30.9844 23.4844 30.9844C23.0781 30.9844 22.7188 31.1406 22.4062 31.4531C22.125 31.7344 21.9844 32.0781 21.9844 32.4844C21.9844 32.8906 22.125 33.25 22.4062 33.5625ZM27.5156 12.9844C28.2031 12.9844 28.7812 13.2344 29.25 13.7344C29.75 14.2344 30 14.8281 30 15.5156V32.4844C30 33.1719 29.75 33.7656 29.25 34.2656C28.7812 34.7656 28.2031 35.0156 27.5156 35.0156H19.5C18.8125 35.0156 18.2188 34.7656 17.7188 34.2656C17.25 33.7656 17.0156 33.1719 17.0156 32.4844V15.5156C17.0156 14.8281 17.25 14.2344 17.7188 13.7344C18.2188 13.2344 18.8125 12.9844 19.5 12.9844H27.5156Z",
    fill: "#596975"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBiCellphone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/bi_cellphone.88f9c5e9.svg";
export { ForwardRef as ReactComponent };